import { Injectable } from "@angular/core";
import { SidenavComponent } from "../components/sidenav/sidenav.component";

@Injectable()
export class SidenavService {
  public sidenav: SidenavComponent;
  public currentTab: string = "";
  constructor() {}

  public setSidenav(sidenav: SidenavComponent) {
    this.sidenav = sidenav;
  }

  public open(): void {
    this.sidenav.open();
    if (!this.sidenav.tabs || this.sidenav.tabs.length == 0) {
      this.sidenav.setTabs();
    }
  }

  public close(): void {
    this.sidenav.close();
  }

  public toggle(): void {
    this.sidenav.toggle();
    if (
      !this.sidenav.tabs ||
      (!this.sidenav.opened && this.sidenav.tabs.length == 0)
    ) {
      this.sidenav.setTabs();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/sidenav.service.ts